import LogOperations from '@modules/husleie-framework/src/static-classes/LogOperations.class';
import { UpsellStatusEnum } from '@modules/husleie-framework/src/types/Upsell.entity';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import api from '@modules/store/upsell/api/index.api';
import {
  DepositSubscriptionGetDetails,
  DepositSubscriptionCreate,
  DepositSubscriptionGet,
} from '@modules/store/upsell/types/UpsellAPI.interface';
import UpsellDepositSubscriptionState from '@modules/store/upsell/types/UpsellDepositSubscriptionState.entity';
import { UserRoleEnum } from '@modules/husleie-framework/src/types/User.entity';
import { ActionTree } from 'vuex';

export const actions: ActionTree<UpsellDepositSubscriptionState, CommonState> = {
  fetchDepositSubscriptionDetails: ({ commit }, get: DepositSubscriptionGetDetails) => {
    commit('common/staticData/setLoading', true, { root: true });
    commit('setUpsellDepositSubscriptionLoading', true);
    commit('common/staticData/setApiError', { error: false }, { root: true });
    commit('setUpsellDepositSubscriptionApiError', false);
    return new api()
      .getDepositSubscriptionDetails(get)
      .then((data: any) => {
        commit('setUpsellDepositSubscriptionDetails', data.upsellPrice);
      })
      .catch((error: any) => {
        commit('common/staticData/setApiError', { error: true }, { root: true });
        commit('setUpsellDepositSubscriptionApiError', true);
        LogOperations.error('Upsell|DepositSubscription|Actions|fetchDepositSubscriptionDetails', error.message);
        throw new Error('fetchDepositSubscriptionDetails');
      })
      .finally(() => {
        commit('common/staticData/setLoading', false, { root: true });
        commit('setUpsellDepositSubscriptionLoading', false);
      });
  },

  createDepositSubscription: ({ commit }, create: DepositSubscriptionCreate) => {
    commit('common/staticData/setLoading', true, { root: true });
    commit('setUpsellDepositSubscriptionLoading', true);
    commit('common/staticData/setApiError', { error: false }, { root: true });
    commit('setUpsellDepositSubscriptionApiError', false);
    return new api()
      .createDepositSubscription(create)
      .then((data: any) => {
        commit('setUpsellDepositSubscriptionUuid', data.upsellId);
      })
      .catch((error: any) => {
        commit('common/staticData/setApiError', { error: true }, { root: true });
        commit('setUpsellDepositSubscriptionApiError', true);
        LogOperations.error('Upsell|DepositSubscription|Actions|createDepositSubscription', error.message);
        throw new Error('createDepositSubscription');
      })
      .finally(() => {
        commit('common/staticData/setLoading', false, { root: true });
        commit('setUpsellDepositSubscriptionLoading', false);
      });
  },

  fetchDepositSubscription: ({ commit }, get: DepositSubscriptionGet) => {
    commit('common/staticData/setLoading', true, { root: true });
    commit('setUpsellDepositSubscriptionLoading', true);
    commit('common/staticData/setApiError', { error: false }, { root: true });
    commit('setUpsellDepositSubscriptionApiError', false);
    return new api()
      .getDepositSubscription(get)
      .then((data: any) => {
        commit('setUpsellDepositSubscription', data.upsellDepositSubscription);
      })
      .catch((error: any) => {
        commit('common/staticData/setApiError', { error: true }, { root: true });
        commit('setUpsellDepositSubscriptionApiError', true);
        LogOperations.error('Upsell|DepositSubscription|Actions|fetchDepositSubscription', error.message);
        throw new Error('fetchDepositSubscription');
      })
      .finally(() => {
        commit('common/staticData/setLoading', false, { root: true });
        commit('setUpsellDepositSubscriptionLoading', false);
      });
  },

  assignDepositSubscriptionOpportunity: async (
    { commit, dispatch },
    { depositSubscriptionOpportunity, signingUuid }
  ) => {
    commit('setUpsellDepositSubscriptionUuid', depositSubscriptionOpportunity.uuid);

    // Initial opportunity status, will be overwritten when the 'open' upsell is fetched
    commit('setUpsellDepositSubscriptionStatus', depositSubscriptionOpportunity.status);

    if (depositSubscriptionOpportunity.status === UpsellStatusEnum.OPEN) {
      // This is a temporary workaround, we should receive the prices in 'fetchDepositSubscription'
      await dispatch('fetchDepositSubscriptionDetails', { uuid: signingUuid, userType: UserRoleEnum.TENANT }); // get pricing, ...

      if (depositSubscriptionOpportunity.uuid) {
        await dispatch('fetchDepositSubscription', { uuid: depositSubscriptionOpportunity.uuid });
      }

      commit('setUpsellDepositSubscriptionLoaded', true);
    }
  },
};
